import React, { useState, Component } from 'react';
import { useContext } from "react";
import AuthContext from "../../AuthContext";
import { Navigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft, faCircle, faCheckCircle, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { getShoppingLists, getShoppingListItems, createShoppingListItem, updateShoppingListItem, deleteShoppingListItem } from '../../api/backend';
import { Application } from '../../core/app';
import { escapeHtml } from '../../utils/sanitize';


class ShoppingItems extends Component {

    state = {
        items: [],
        inputValue: '',
    }

    componentDidMount() {
        // Items will be loaded by parent component
    }


    getItems = (id) => {
        getShoppingListItems(id).then(res => {
            
            const items = res.data.items;
            const total_quantity = res.data.total_quantity;
            const total_amount = res.data.total_amount;

            this.setState({ items });
            this.props.setItemTotals(total_quantity, total_amount);
        });
    }

    setItems = (newItems) => {
        this.setState({ newItems });
    }

    setInputValue = (value) => {
        this.setState({ inputValue: value });
    }


    // HINT: each "item" in our list names a name,
    // a boolean to tell if its been completed, and a quantity


    handleAddButtonClick = () => {
        let selected_id = Application.getSelectedShoppingList();

        const newItem = {
            shopping_lists_id: selected_id,
            name: this.state.inputValue,
            quantity: 1,
            isSelected: false,
        };

        createShoppingListItem(newItem).then(res => {
            this.getItems(selected_id);
        });

        const newItems = [...this.state.items, newItem];

        this.setItems(newItems);

        this.setInputValue('');
    };

    updateItem = (item) => {
        updateShoppingListItem(item).then(res => {
            this.getItems(Application.getSelectedShoppingList());
        });
    }

    handleQuantityIncrease = (index) => {
        const newItems = [...this.state.items];
        newItems[index].quantity++;

        this.updateItem(newItems[index]);

        this.setItems(newItems);
    };

    handleQuantityDecrease = (index) => {
        const newItems = [...this.state.items];

        newItems[index].quantity--;

        this.updateItem(newItems[index]);

        this.setItems(newItems);
    };

    handleItemDelete = (item) => {
        deleteShoppingListItem(item.id).then(res => {
            this.getItems(Application.getSelectedShoppingList());
        });
    };

    toggleComplete = (index) => {
        const newItems = [...this.state.items];

        newItems[index].isSelected = !newItems[index].isSelected;

        this.updateItem(newItems[index]);

        this.setItems(newItems);
    };

    formatDollar = (amount) => {

        if (!isNaN(amount)) {
            return '$0';
        }
        
        return '$' . amount
    }


    render() {
        const hasSelectedList = !!this.props.selectedListId;
        const hasItems = Array.isArray(this.state.items) && this.state.items.length > 0;

        return (
            <div className='main-item-container shopping-items-panel'>
                <div className='add-item-box shopping-add-item-box'>
                    <input value={this.state.inputValue} onChange={(event) => this.setInputValue(event.target.value)} className='add-item-input' placeholder='Add an item...' />
                    <button className='shopping-add-button' type='button' onClick={() => this.handleAddButtonClick()} aria-label='Add item'>
                        <FontAwesomeIcon icon={faPlus} />
                    </button>
                </div>
                <div className='item-list'>
                    {!hasSelectedList ? (
                        <div className='shopping-empty-state'>Select a shopping list to view items.</div>
                    ) : !hasItems ? (
                        <div className='shopping-empty-state'>No items yet. Add your first item above.</div>
                    ) : this.state.items.map((item, index) => (
                        <div key={index} className='item-container'>
                            <div className='item-name' onClick={() => this.toggleComplete(index)}>
                                {item.isSelected ? (
                                    <>
                                        <FontAwesomeIcon icon={faCheckCircle} />
                                        <span className='completed'>{escapeHtml(item.name)}</span>
                                    </>
                                ) : (
                                    <>
                                        <FontAwesomeIcon icon={faCircle} />
                                        <span>{escapeHtml(item.name)}</span>
                                    </>
                                )}
                            </div>
                            <div className='item-details shopping-item-details'>
                                <div className='amount shopping-amount'>
                                    <span> { this.formatDollar(item.amount) } </span>
                                </div>
                                <div className='quantity shopping-quantity'>
                                    <button className='quantity-button' type='button' onClick={() => this.handleQuantityDecrease(index)} aria-label={`Decrease quantity for ${escapeHtml(item.name)}`}>
                                        <FontAwesomeIcon icon={faChevronLeft} size='xs' />
                                    </button>
                                    <span className='quantity-value'> {item.quantity} </span>
                                    <button className='quantity-button' type='button' onClick={() => this.handleQuantityIncrease(index)} aria-label={`Increase quantity for ${escapeHtml(item.name)}`}>
                                        <FontAwesomeIcon icon={faChevronRight} size='xs' />
                                    </button>
                                </div>
                                <div className='delete'>
                                    <button className='delete-color shopping-delete-button' type='button' onClick={() => this.handleItemDelete(item)} aria-label={`Delete ${escapeHtml(item.name)}`}>
                                        <FontAwesomeIcon icon={faTrash} />
                                    </button>
                                </div>
                            </div>
                           
                        </div>
                    ))}
                </div>
            </div>
        );
    };
};

export default ShoppingItems